import DRSLogo from '../../assets/images/Logo.png';
import NoDataFound from '../../assets/images/no-Data-found.png';
import contactUsSvg from '../../assets/images/contactUs.svg';
import Dashicon from '../../assets/images/dashboard.svg';
import Adverticon from '../../assets/images/advertiser.svg';
import Clubicon from '../../assets/images/club.svg';
import Revenewicon from '../../assets/images/revenew.svg';
import Ordericon from '../../assets/images/order.svg';
import Transicon from '../../assets/images/transaction.svg';
import Stafficon from '../../assets/images/staff.svg';
import Logouticon from '../../assets/images/logout.svg';
import ClubRequests from '../../assets/images/clubsRequest_icon.svg';
import UpdateStaff from '../../assets/images/updateStaff.svg'
import Couponicon from '../../assets/images/coupon.png';

export const ImagePath = {
  DRSLogo,
  NoDataFound,
  contactUsSvg,
  Dashicon,
  Adverticon,
  Couponicon,
  Clubicon,
  Revenewicon,
  Ordericon,
  Transicon,
  Stafficon,
  Logouticon,
  ClubRequests,
  UpdateStaff
};
